<template>
  <b-modal
    :active.sync="active_"
    has-modal-card
    class="import-modal"
    @close="close"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">
          {{ code ? "Update" : "Create" }} Code
        </p>
      </header>
      <section class="modal-card-body">
        <b-field label="Name">
          <b-input v-model="form.name"></b-input>
        </b-field>
        <b-field label="Code">
          <b-input v-model="form.code"></b-input>
        </b-field>
        <b-field label="Group">
          <b-input v-model="form.group"></b-input>
        </b-field>
        <b-field label="Data">
          <b-input v-model="form.data" type="textarea"></b-input>
        </b-field>
        <base-tag-input :value.sync="form.tags" allow-new />
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">Cancel</b-button>
        <b-button :loading="loading" @click.prevent="submitCode">
          Save
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import BaseTagInput from "@/components/partials/BaseTagInput";
import { CodeService } from "@/services/code.service";
import { ContractService } from "@/services/contract.service";

export default {
  codeService: CodeService,
  contractService: ContractService,
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    code: {
      type: Object,
    },
    firmId: {
      type: [String, Number],
    },
    contractId: {
      type: [String, Number],
    },
    type: {
      type: String,
    },
  },
  components: {
    BaseSelect,
    BaseTagInput,
  },
  data: () => ({
    active_: false,
    form: {
      name: "",
      code: "",
      group: "",
      data: "",
      tags: [],
    },
    loading: false,
  }),
  watch: {
    active(active) {
      this.active_ = active;
    },
    active_(active) {
      if (active) {
        this.setForm();
      }
      this.$emit("update:active", active);
    },
  },
  methods: {
    setForm() {
      if (this.code) {
        this.form.name = this.code.name;
        this.form.code = this.code.code;
        this.form.group = this.code.group;
        this.form.data = this.code.data ? JSON.stringify(this.code.data) : "";
        this.form.tags = (this.code.tags || []).map((v) => v.name);
      }
    },
    clearForm() {
      this.form = {
        name: "",
        code: "",
        group: "",
        data: "",
        tags: [],
      };
    },
    close() {
      this.clearForm();
      this.$emit("close");
      this.active_ = false;
    },
    transformData() {
      let data = {
        ...this.form,
        firm_id: this.firmId || undefined,
        contract_id: this.contractId || undefined,
        type: this.type || undefined,
      };
      try {
        data.data = JSON.parse(data.data);
      } catch (err) {
        data.data = undefined;
      }
      return data;
    },
    async submitCode() {
      try {
        if (this.code) {
          await CodeService.update(this.code.id, this.transformData());
        } else {
          await CodeService.create(this.transformData());
        }
        this.$buefy.toast.open({
          message: `Code has been ${this.code ? "updated" : "created"}.`,
          type: "is-info",
          position: "is-top-right",
        });
        this.$emit("submit");
        this.close();
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Code/CodeFormModal.vue